import { grpcPost, grpcGet, httpGet, httpPost } from "src/utils/httpRequest";
import { getConfig } from "./server-url-config/env";

const urlConfig = getConfig();
const apiGatewayPrefix = urlConfig.apiUrl.apiGatewayPrefix;
const productUrl = `${urlConfig.apiUrl.apiGatewayPrefix}${urlConfig.apiUrl.dm}`;

/**
 * @returns 
 */
export async function getAllProductList() {
  return httpPost(`${apiGatewayPrefix}/dm/v1/robots/external/productFamilyCode/list`, {pageNumber: 1, pageSize: 200}, true)
}

export async function addProduct(productId:string, body = {}) {
  return grpcPost(`${productUrl}/products/${productId}:create`, body)
}